import React from 'react';

const BaseIcon = ({ SVGElement, color = '#1b62ab', size = 24, children, ...props }) => {
  const className = 'mdi-icon ' + (props.className || '');
  return <SVGElement {...props} className={className} width={size} height={size} fill={color} style={{ ...props.style, fill: color }} />;
};

export default React.memo ? React.memo(BaseIcon) : BaseIcon;
